import { sdkContextStatus } from "src/context/SDKContext"
import { useQuery } from "react-query"
import { RoomValidationResult } from "src/context/types"

const QUERY_KEY = "requestx-page-styling"

type PageStylingKeys = keyof RoomValidationResult

function usePageStyling(key: PageStylingKeys) {
  const { data } = useQuery({
    queryKey: [QUERY_KEY],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const meetingClient = await sdkContextStatus
      const response = await meetingClient.validateAndGetRoomBranding()
      return response
    }
  })

  if (data && !data[key] && import.meta.env.MODE === "development") {
    throw new TypeError("Invalid KEY")
  }
  return data ? data[key] : null
}

export default usePageStyling
